<!-- <mat-form-field *ngIf="showField$ | async">
<mat-select
  [attr.name]="field.name"
  [placeholder]="field.label | translate"
  [formControl]="field.control">
  <mat-option *ngFor="let o of field.options" [value]="o.value">
    {{ o.label }}
  </mat-option>
</mat-select>
<mat-hint *ngIf="hasDanger()" [ngStyle]="{'color': 'red'}" align="start">{{errorText()}}</mat-hint>
<mat-hint *ngIf="field.help && !hasDanger()" align="start">{{field.help | translate}}</mat-hint>
</mat-form-field> -->


@if (showField$ | async) {
  <mat-form-field>
    @if (field.label) {
      <mat-label>{{ field.label | translate }}</mat-label>
    }
    <input matInput [required]="!!field.validators?.required" [formControl]="$any(field.control)" [placeholder]="field.placeholder | translate" [matAutocomplete]="auto">
    <mat-autocomplete #auto="matAutocomplete" [autoActiveFirstOption]="true" [displayWith]="displayLabel.bind(this)">
      @for (o of filteredOptions | async; track o) {
        <mat-option [value]="o.value">
          {{o.label}}
        </mat-option>
      }
    </mat-autocomplete>
    @if (hasDanger()) {
      <mat-hint [ngStyle]="{'color': 'red'}" align="start">{{errorText()}}</mat-hint>
    }
    @if (field.help && !hasDanger()) {
      <mat-hint align="start">{{field.help | translate}}</mat-hint>
    }
  </mat-form-field>
}
